import { render } from "./Order.vue?vue&type=template&id=a89264c4&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=a89264c4&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a89264c4"]])

export default __exports__